var money_format = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);var n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));var o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};
var shop_curr = $('#shop_currency_val').text();
function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => changeItem(data_line,0));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
      });
    });
    setTimeout(function (params) {
      $('.cart-sidebar form').addClass('loadajaxcd');
    },1000);
    var cart_drawer_btm = $('.bar-cdrawer').outerHeight() + $('.cad_topcls').outerHeight();
    $('.cart-totals').css('transform','translateY(calc(100% - '+cart_drawer_btm+'px))');
    $('.cart-totals').bind('swipedown', closecdbox);
    function closecdbox(event) {       
      /*$('body').removeClass('show-c-overlay');*/
      setTimeout(function (params) {
       $('.cad_topcls').removeClass('opentopcd');
      },00);
      var cart_drawer_btm = $('.bar-cdrawer').outerHeight() + $('.cad_topcls').outerHeight();
      $('.cart-totals').css('transform','translateY(calc(100% - '+cart_drawer_btm+'px))');     
    }
    $('.cart-totals').bind('swipeup', opencdbox);
    function opencdbox(event) {       
      $('.cad_topcls').addClass('opentopcd'); 
      /*$('body').addClass('show-c-overlay');*/
      $('.cart-totals').css('transform','translateY(0)');     
    }
    $('.cm-sticky-details').bind('swipedown', opencdoptions);
    function opencdoptions(event) { 
      $('.cm-sticky-details').removeClass('opensticky-details');
      $('.cart-sidebar').removeClass('do-overlay');
    }
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
      	document.querySelector('.cart-count').innerHTML = cart_count;
      }else{
      	document.querySelector('.cart-count').innerHTML = '';
      }                        
      function currentcountry(response) {
        var country_name = response.country_name;
        var all_coutry_list = [];
        var new_alllist = '';
        $('.country_list').each(function(e){
          var eachcountry = $(this).data('country');
          if(eachcountry.indexOf(country_name) != -1){
            $(this).addClass('active');
          }
          new_alllist += eachcountry+',';
        });
        var currency_rate = Shopify.currency.rate;
        var cart_totalprice = data.total_price;        
        if(new_alllist.indexOf(country_name) != -1){
          var cartfree_cost = parseFloat($('.country_list.active').data('cartprice')*currency_rate);
          var delivery_cost = parseFloat($('.country_list.active').data('delivery')*currency_rate); 
          var remain_cost = parseFloat($('.country_list.active').data('final')*currency_rate); 
          var cart_shiptext = $('.country_list.active').data('shiptitle');
          if(cart_totalprice>=cartfree_cost){
            //$('.cart-eastimatecost').html(money_format(0,shop_curr));
            $('.cart-eastimatecost').html(money_format(0,shop_curr));
            $('.cd_not_free_ship').removeClass('active');
            $('.cd_free_ship').addClass('active');            
          }else{
            //$('.cart-eastimatecost').html(money_format(delivery_cost,shop_curr));
            $('.cart-eastimatecost').html(money_format(remain_cost,shop_curr));
            $('.cd_not_free_ship').addClass('active');
            $('.cd_free_ship').removeClass('active');
          }
          if(cart_shiptext != '' ){
            $('.cd_not_free_ship').removeClass('active');
            $('.cd_free_ship').removeClass('active');
            $('.finalshiptext').text(cart_shiptext);
          }
        }else{
          var cartfree_cost = parseFloat($('.other_cost').data('cartprice')*currency_rate);
          var delivery_cost = parseFloat($('.other_cost').data('delivery')*currency_rate);
          var remain_cost = parseFloat($('.other_cost').data('final')*currency_rate); 
          if(cart_totalprice>=cartfree_cost){
            //$('.cart-eastimatecost').html(money_format(0,shop_curr));
           $('.cart-eastimatecost').html(money_format(0,shop_curr));
            $('.cd_not_free_ship').removeClass('active');
            $('.cd_free_ship').addClass('active');
          }else{
            //$('.cart-eastimatecost').html(money_format(delivery_cost,shop_curr));
            $('.cart-eastimatecost').html(money_format(remain_cost,shop_curr));
            $('.cd_not_free_ship').addClass('active');
            $('.cd_free_ship').removeClass('active');
          }
        }
      }
      _ipgeolocation.getGeolocation(currentcountry, "ae3dd081993248b095346222d266ab88");
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function displayLoading(){
  document.querySelector('.cart-sidebar').classList.add('loading-drawer');
}
function hideLoading(){
  document.querySelector('.cart-sidebar').classList.remove('loading-drawer');
}
function changeItem(data_line,qty){
  const data = {'line': data_line ,'quantity':qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
    setTimeout(function(){
      hideLoading();
    },800);
  })
  .catch((error) => {
    hideLoading();
    console.error('Error:', error);
  });
}
$(document).on('click','.cd-plus', function () {
  var $qty = $(this).parents('.cd-qty-box').find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal+1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.item-row').data('line');
    displayLoading();
    changeItem(data_line,input_qty);
  }
});
$(document).on('click','.cd-minus', function () {
  var $qty = $(this).parents('.cd-qty-box').find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.item-row').data('line');
    displayLoading();
    changeItem(data_line,input_qty);
  }
});
$(document).on('click','.change-items',function(e){
  e.preventDefault();
  $(this).closest('.item-row').find('.item-dropdown').slideToggle().closest('.item-row').siblings().find('.item-dropdown').slideUp();
  $(this).toggleClass('active').closest('.item-row').siblings().find('.change-items').removeClass('active'); 
});
$(document).on('click','.item-dropdown li,.cp-variant-dropdown li',function(e){
  e.preventDefault();
  var item_current_id = $(this).data('id');
  var item_current_qty = $(this).data('qty');
  var currentid = $(this).data('current');
  var cartpage_error = $(this).closest('.cp-items-row');
  var cartdrawer_error = $(this).closest('.item-row');
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: item_current_id, quantity: item_current_qty },
    dataType: "json",
    beforeSend: function () {
      
    },
    success: function (t) {          
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + currentid,
        dataType: "json",
        beforeSend: function () {
			displayLoading();
        },
        success: function (e) {
          if(window.location.href.includes('cart'))
          {
            window.location.href = "/cart";
          }else{
            load_cart();
          }
        },
        error: function (e, t) {
          console.log(e.responseJSON.description);              
        },
        complete: function(){
          hideLoading();
        }
      });
    },
    error: function (e, t) {
      console.log(e.responseJSON.description);
      $(cartpage_error).find('.cartpage_error').text(e.responseJSON.description);
      $(cartdrawer_error).find('.cartpage_error').text(e.responseJSON.description);
    },
  });
});
$(document).on('click','.match-cart',function(e){
  e.preventDefault();
  var match_id = $(this).data('id');
  var _this = $(this).closest('.match-grid');
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: match_id, quantity: 1 },
    dataType: "json",
    success: function (t) {
      if(window.location.href.includes('cart'))
      {
        window.location.href = "/cart";
      }else{
        load_cart();
      }
      $(".cart-sidebar").animate({ scrollTop: 0 }, "slow");
    },
    error: function (e, t) {
      _this.find('.match-error').text(e.responseJSON.description);
      setTimeout(function(){
        _this.find('.match-error').text('');
      }, 2000);
    },
  });
});
$(document).on('click','.drawer-mobile-action ul li',function(e){
  e.preventDefault();
  $(this).addClass('active').siblings().removeClass('active');
  $(this).closest('.item-row').find('.cdv-variants span').text($(this).data('text'));
  $(this).closest('.item-row').find('.cdv-variants').addClass('show-cdv-variants');
  if($(this).closest('.item-row').find('.cdv-qty').hasClass('show-cdv-qty')){
    $(this).closest('.item-row').find('.change-cd-btn').addClass('bothcls');
  }
  $(this).closest('.item-row').find('.current-cdv-btn').hide();
  $(this).closest('.item-row').find('.change-cd-btn').show();
});
$(document).on('click','.mcd-plus', function (e) {
  e.preventDefault();
  var $qty = $(this).parents('.cd-qty-box').find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal+1);
    $(this).closest('.item-row').find('.cdv-qty span').text(currentVal+1);
    $(this).closest('.item-row').find('.cdv-qty').addClass('show-cdv-qty');
    if($(this).closest('.item-row').find('.cdv-variants').hasClass('show-cdv-variants')){
      $(this).closest('.item-row').find('.change-cd-btn').addClass('bothcls');
    }
    $(this).closest('.item-row').find('.current-cdv-btn').hide();
    $(this).closest('.item-row').find('.change-cd-btn').show();
  }
});
$(document).on('click','.mcd-minus', function (e) {
  e.preventDefault();
  var $qty = $(this).parents('.cd-qty-box').find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    $(this).closest('.item-row').find('.cdv-qty span').text(currentVal-1);
    $(this).closest('.item-row').find('.cdv-qty').addClass('show-cdv-qty');
    if($(this).closest('.item-row').find('.cdv-variants').hasClass('show-cdv-variants')){
      $(this).closest('.item-row').find('.change-cd-btn').addClass('bothcls');
    }
    $(this).closest('.item-row').find('.current-cdv-btn').hide();
    $(this).closest('.item-row').find('.change-cd-btn').show();
  }
});
$(document).on('click','.current-cdv-btn',function(e){
  e.preventDefault();
  $(this).closest('.item-row').find('.cm-sticky-details').removeClass('opensticky-details');
  $('.cart-sidebar').removeClass('do-overlay');
});
$(document).on('click','.change-cd-btn',function(e){
  e.preventDefault();
  var item_current_id = $(this).closest('.item-row').find('.drawer-mobile-action li.active').attr('data-id');
  var item_current_qty = $(this).closest('.item-row').find('.cm-sticky-details .cd-quantity-input').val();
  var currentid = $(this).closest('.item-row').find('.drawer-mobile-action li.active').attr('data-current');
  var carterror = $(this).closest('.item-row').find('.cd-error');
  var cartpage_error = $(this).closest('.cp-items-row');
  //$(this).closest('.item-row').find('.cm-sticky-details').removeClass('opensticky-details');            
  if(currentid != item_current_id){
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: item_current_id, quantity: item_current_qty },
      dataType: "json",
      beforeSend: function () {
      },
      success: function (t) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&id=" + currentid,
          dataType: "json",
          success: function (e) {
            $.ajax({
              type: 'GET',
              url: '/cart',
              dataType: "html",
              success: function(data){  
                $('.cart-sidebar').removeClass('do-overlay');
                if(window.location.href.includes('cart'))
                {
                  window.location.href = "/cart";
                }else{
                  load_cart();
                }
              },
              error: function(error) {
                console.log(error);                
              },
            });                    
          },
          error: function (e, t) {
            $(carterror).text(e.responseJSON.description);
            setTimeout(function(){
              $(carterror).text('');
            }, 2000);
          }
        });
      },
      error: function (e, t) {
        $(carterror).text(e.responseJSON.description);
        setTimeout(function(){
          $(carterror).text('');
        }, 2000);
      },
    });
  }else{
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity="+item_current_qty+"&id=" + currentid,
      dataType: "json",
      beforeSend: function () {
      },
      success: function (t) {
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: "html",
          success: function(data){  
            $('.cart-sidebar').removeClass('do-overlay');
            if(window.location.href.includes('cart'))
            {
              window.location.href = "/cart";
            }else{
              load_cart();
            }
          },
          error: function(error) {
            console.log(error);
            //$(this).closest('.item-row').find('.cm-sticky-details').removeClass('opensticky-details');
          },
        });     
      },
      error: function (e, t) {
        $(carterror).text(e.responseJSON.description);
        setTimeout(function(){
          $(carterror).text('');
        }, 2000);
      },
    });
  }
});
$(document).on('click','.mob-change-btn',function(e){
  e.preventDefault();
  $(this).closest('.item-row').find('.cm-sticky-details').addClass('opensticky-details');
  $('.cart-sidebar').addClass('do-overlay');
});
$(document).on('click','.drawer-overlay,.mobile-itemtitle',function(e){
  e.preventDefault();
  $('.cart-sidebar').removeClass('do-overlay');
  $('.cm-sticky-details').removeClass('opensticky-details');
  $('body').removeClass('show-c-overlay');
  $('.cp-static-wrap').removeClass('hide');
  //$('.csticky-total').slideUp();
  var cart_drawer_btm = $('.bar-cdrawer').outerHeight() + $('.cad_topcls').outerHeight();
  $('.cart-totals').css('transform','translateY(calc(100% - '+cart_drawer_btm+'px))'); 
});
var Shopify = Shopify || {};
Shopify.money_format = $('#shop_currency_val').text();
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
document.body.addEventListener('docapp-discount-applied', (e) => {
  $('.cptotalprice,.cd-checkoutdot').html(Shopify.formatMoney(e.estimatedTotal));
  var discountlen = JSON.stringify(e.discounts.length);
  if(discountlen > 0){
    $('.cart-sidebar').addClass('discount-apply');
  }else{
    $('.cart-sidebar').removeClass('discount-apply');
  }
});